<template>
	<sf-data-table
		ref="CarSaleTable"
		paging
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		:columns="carSaleCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		:selection="false"
		:customExcel="excelFunc"
		@changedPage="changedPage"
		fit="fit"
		creatable
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'wrntStrtDdManual'">
				<span >{{ slotProps.row.wrntStrtDdManual === '1' ? 'Y' : 'N' }}</span>
			</template>
		</template>
		<template v-slot:actionsLeft> </template>
		<template v-slot:actionsRight>
			<!--엑셀업로드-->
			<sf-button v-if="isButton_(scrId, 'EU')" line icon="excel" :onClick="openModal">
				{{ getMessage_('QWCC000927') }}
			</sf-button>
			<!--엑셀템플릿 다운-->
			<sf-button v-if="isButton_(scrId, 'EU')" line icon="excel" hidden :onClick="downExcelTemp">
				{{ getMessage_('QWCC001799') }}
			</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/CarSale/store/helpers';

/*엑셀다운로드 시작*/
import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
/*엑셀다운로드 끝*/
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			//그리드 로우
			return this.carSaleList;
		},
		carSaleCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('QWCC001538'), // 제품 ID
					prop: 'pmcId',
					width: '200px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000974'), // 제품 No
					prop: 'pmcNo',
					width: '200px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001008'), // HTWO법인
					prop: 'htwoCorpNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001544'), // 공장
					prop: 'plntNm',
					width: '110px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001999'), // HTWO생산일
					prop: 'erpProdDd',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001044'), // HTWO판매일
					prop: 'erpSaleDd',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001009'), // JV업체명
					prop: 'jvCpnyNm',
					width: '100px',
					headerAlign: 'center'
				},
				{
					label: this.getMessage_('QWCC001010'), // JV판매일
					prop: 'jvSaleDd',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002099'), // SI업체명
					prop: 'siCpnyNm',
					width: '100px',
					headerAlign: 'center'
				},
				{
					label: this.getMessage_('QWCC002101'), // SI판매일
					prop: 'siSaleDd',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001541'), // OEM법인명
					prop: 'oemCpnyNm',
					width: '150px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001542'), // 판매국가
					prop: 'saleNatNm',
					width: '100px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001019'), // 판매지역
					prop: 'saleRegnNm',
					width: '150px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001959'), // 판매상세지역
					prop: 'dtlRegn',
					width: '150px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001012'), // OEM판매일
					prop: 'oemSaleDd',
					width: '130px',
					align: 'center'
				},
				// {
				// 	label: this.getMessage_('QWCC002009'), // 보증만료일
				// 	prop: 'wrntEndDd',
				// 	width: '130px',
				// 	align: 'center'
				// },
				{
					label: this.getMessage_('QWCC001013'), //고객사업체명
					prop: 'custNm',
					width: '180px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001015'), //차량구분
					prop: 'carScnNm',
					width: '110px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001017'), //승상구분
					prop: 'pacScnNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001016'), // 차량유형
					prop: 'carTypeNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001018'), //동력유형
					prop: 'pwrTypeNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000960'), //차량VIN
					prop: 'carVin',
					width: '200px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001543'), // 운행지역
					prop: 'croRegnNm',
					width: '150px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001960'), // 운행상세지역
					prop: 'croDtlRegn',
					width: '150px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002102'), // 质保
					prop: 'wrntStrtDd',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002136'), 
					prop: 'wrntStrtDdManual',
					minWidth: '170px',
					align: 'center',
					custom: true,
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001351'), // 보증기간(년)
					prop: 'usePrd',
					width: '100px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001023'), // 보증사용거리(만Km)
					prop: 'milg',
					headerAlign: 'center',
					width: '180px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002119'), // 车牌号
					prop: 'licensePlate',
					headerAlign: 'center',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002122'),  //行驶证注册日
					prop: 'vehicleRegDt',
					minWidth: '130px',
					align: 'center',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC002123'), // 整车质保起始日
					prop: 'carWrntStrtDd',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002087'), // 보증사용거리(만Km)
					prop: 'mipCd',
					headerAlign: 'center',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001021'), // 연료전지사양
					prop: 'flclSpcNm',
					headerAlign: 'center',
					width: '120px'
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		openModal() {
			// 엑셀업로드팝업 호출
			const param = {
				title: this.getMessage_('QWCC001159'), //타이틀바 값 PMC No 엑셀 업로드
				apiGubun: 'CAR_SALE', //업무구분값
				flag: 'I' //INSERT는 i Update U로 만듬
				//param1: '' //
			};
			this.$emit('PopupOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			let strtMm01, endMm01;

			if (this.searchParams.strtMm01) {
				strtMm01 = this.$moment(this.searchParams.strtMm01).format('YYYYMMDD');
			} else {
				strtMm01 = '';
			}
			if (this.searchParams.endMm01) {
				endMm01 = this.$moment(this.searchParams.endMm01).format('YYYYMMDD');
			} else {
				endMm01 = '';
			}

			queryStr = objectToQuerystring({
				pmcId: this.searchParams.pmcId, //제품ID
				pmcNo: this.searchParams.pmcNo, //제품NO
				flclSpc: this.searchParams.flclSpc, //연료전지사양
				saleRegn: this.searchParams.saleRegn, //판매지역
				carVin: this.searchParams.carVin, //차량 VIN
				carScn: this.searchParams.carScn, //차량구분
				srchMm03: this.searchParams.srchMm03, //날짜구분
				pwrType: this.searchParams.pwrType, //동력유형
				pacScn: this.searchParams.pacScn, //승상구분
				idxScn:this.searchParams.idxScn,
				strtMm01: strtMm01, //
				endMm01: endMm01 //

				// strtMm01: strtMm01, //strtMm01
				// endMm01: endMm01 //endMm01
			});
			//console.log(' 되냐', queryStr);

			const url = `${BASE_URL}/mqy/qlty/carSale/v1/carSales/excel` + queryStr;

			const params = { url, columns: this.carSaleCols };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		downExcelTemp() {
			let params = {
				//origFileName: 'carsale.xlsx'
				apiGubun: 'CAR_SALE'
			};

			this.excelTempDown_(params)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message || this.getMessage_('QWCC001920') //권한이 없거나 다운로드 할 수 없습니다.
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		resetTable() {
			this.$emit('Refresh');
		},
		//페이징 처리
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				// return;
			}

			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		}
	}
};
</script>

<style></style>
